import React from 'react'
import PropTypes from 'prop-types'
import './ErrorDisplay.css'
import 'font-awesome/css/font-awesome.css'

const ErrorDisplay = (props) => {
	if (props.err && props.err.errorMessage) {
		return (
			<p className="error">
				{props.err.errorMessage}
			</p>
		)
	} else {
		return (<div/>)
	}
}

ErrorDisplay.propTypes = {
	err: PropTypes.object
}

export default ErrorDisplay


// WEBPACK FOOTER //
// ./src/components/ErrorDisplay/ErrorDisplay.js